import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Common Reusable Truncated Pagination Component
 */
const getPaginationRange = (current, total, delta = 1) => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const range = [];
  const rangeWithDots = [];
  let l;

  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};

const CustomPagination = ({
  currentPage = 1,
  totalRecords = 0,
  recordsPerPage = 10,
  onPageChange,
  onRecordsPerPageChange,
  showRecordsPerPage = true,
  recordsPerPageOptions = [10, 20, 30, 50, 100],
  labelText = "Records per page",
}) => {
  const totalPagesCount = Math.ceil(totalRecords / recordsPerPage) || 1;

  if (totalRecords <= 0) return null;

  return (
    <div className="handover-pagination-container">
      {showRecordsPerPage ? (
        <div className="records-per-page">
          <span>{labelText}:</span>
          <select
            className="records-select"
            value={recordsPerPage}
            onChange={(e) => onRecordsPerPageChange?.(Number(e.target.value))}
          >
            {recordsPerPageOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div />
      )}

      <div className="pagination-controls">
        <button
          type="button"
          className="page-btn"
          onClick={() => onPageChange?.(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          <ChevronLeft size={16} />
        </button>

        {getPaginationRange(currentPage, totalPagesCount).map((item, index) =>
          item === "..." ? (
            <span key={`page-dots-${index}`} className="pagination-dots">
              ...
            </span>
          ) : (
            <button
              type="button"
              key={`page-num-${item}`}
              className={`page-btn ${currentPage === item ? "active" : ""}`}
              onClick={() => onPageChange?.(item)}
            >
              {item}
            </button>
          )
        )}

        <button
          type="button"
          className="page-btn"
          onClick={() => onPageChange?.(Math.min(currentPage + 1, totalPagesCount))}
          disabled={currentPage === totalPagesCount}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default CustomPagination;
